<div class="config-select-body">
  <button type="button" class="config-select-close" aria-label="Close" (click)="close()">&times;</button>

  <img class="config-select-logo" src="assets/SCRAII_LoginLogo.svg" alt="SCRAII" />
  <h2 class="config-select-title">Select Config</h2>

  <mat-form-field appearance="outline" class="matFformFieldConfigType">
    <mat-label>Config Type</mat-label>
    <mat-select [(ngModel)]="selectConfig" panelClass="config-select-panel">
      <mat-option *ngFor="let config of configs" [value]="config.config_typ" title="{{ config.config_typ }}">{{ config.config_typ }}</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="config-select-actions">
    <button
      type="button"
      class="btn btn-primary btn-sm confirmBtnHomePopups"
      matTooltipClass="popup-confirm-tooltip"
      [disabled]="!selectConfig"
      (click)="selectedConfig(selectConfig)"
    >
      Confirm
    </button>
  </div>
</div>
